import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PublicRoute: React.FC = () => {
  const userData = localStorage.getItem("user-data");
  const user = userData ? JSON.parse(userData) : null;

  // If logged in, redirect away from login/register/forgot
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  // Otherwise, allow access
  return <Outlet />;
};

export default PublicRoute;